<template>
  <div>
    <v-text-field
      v-model="search"
      class="search-input"
      append-icon="search"
      label="Поиск"
      color="accent"
      single-line
      hide-details
    />
    <paginated-table
      :items="items"
      :headers="headers"
      :search="search"
      :loading="loading"
      :pagination.sync="pagination"
      :pullFunction="pullFunction"
    >
      <template #items="props">
        <template v-for="(header, i) in headers">
          <v-btn
            v-if="header.value === 'id'"
            text
            small
            :to="{ name: 'lottery', params: { lottery: props.item.id } }"
            class="lottery-btn"
          >
            {{ props.item.id }}
          </v-btn>

          <td v-else-if="header.value === 'action'" class="center">
            <v-btn
              style="margin-top: 18px"
              small
              fab
              :disabled="getLotteryStatus(props.item).disable"
              color="secondary"
              @click="removeLottery(props.item.id)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </td>

          <td v-else-if="header.value === 'processed'">
            {{ getLotteryStatus(props.item).status }}
          </td>

          <td v-else :key="i">{{ props.item[header.value] }}</td>
        </template>
      </template>
    </paginated-table>

    <v-snackbar
      v-model="showSnackbar"
      :color="success ? 'green' : 'red'"
    >
      <p style="margin: 0 auto">{{ snackbarText }}</p>
    </v-snackbar>
  </div>
</template>

<script>
import { deleteLottery, getOldLotteries } from '../../../../../api/lotteries'

export default {
  name: 'LotteriesTable',
  data () {
    return {
      search: '',
      pagination: {
        sortBy: 'created_at',
        descending: true
      },
      loading: true,
      headers: [
        { text: 'Lottery ID', value: 'id' },
        {
          text: 'ID создателя розыгрыша', value: 'creator_id', sortable: false
        },
        {
          text: 'Сумма выигрыша', value: 'win_amount', sortable: false
        },
        {
          text: 'Количество победителей', value: 'count_winners', sortable: false
        },
        { text: 'Дата и время создания розыгрыша', value: 'created_at' },
        { text: 'Дата и время окончания розыгрыша', value: 'finished_at' },
        {
          text: 'Условие по рефералу', value: 'condition_only_referrals', sortable: false
        },
        {
          text: 'Условие по статусу', value: 'condition_allowed_statuses_info', sortable: false
        },
        {
          text: 'Условие по сумме пополнения', value: 'condition_replenishment_sum', sortable: false
        },
        {
          text: 'Условие по сроку пополнения', value: 'condition_replenishment_from', sortable: false
        },
        {
          text: 'Статус обработки розыгрыша', value: 'processed', sortable: false
        },
        {
          text: 'Отменить розыгрыш', value: 'action', sortable: false
        }
      ],
      showSnackbar: false,
      success: false,
      snackbarText: '',
      items: []
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created () {
    this.pullFunction(1)
  },
  methods: {
    getLotteryStatus (item) {
      const now = new Date()
      const finishedAt = item.finished_at ? new Date(`${item.finished_at}Z`) : null
      if (item.finished_at === null && !item.processed)
        return { status: 'Отменён', disable: true }

      if (finishedAt && finishedAt >= now && !item.processed)
        return { status: 'В процессе', disable: false }

      if (finishedAt && finishedAt < now && item.processed)
        return { status: 'Завершен', disable: true }
    },
    removeLottery (id) {
      deleteLottery(id)
        .then(response => {
          this.success = true
          this.snackbarText = 'Розыгрыш отменен.'
          this.showSnackbar = true
          this.pullFunction(1)
        })
        .catch(err => {
          this.snackbarText = err.response.data.message
          if (err.response.data.message === 'This action is unauthorized.')
            this.snackbarText = 'У вас нет прав на отмену розыгрыша.'
          this.success = false
          this.showSnackbar = true
        })
    },
    pullFunction (page) {
      const numberToTextMap = {
        0: 'New',
        1: 'Bronze',
        2: 'Silver',
        3: 'Gold',
        4: 'Platinum',
        5: 'Diamond'
      }
      getOldLotteries({
        limit: 26, offset: (page - 1) * 25, sort: 'created_at:desc'
      }).then(response => {
        this.items = response.data
        this.items.forEach(i => {
          i.condition_allowed_statuses_info = i.condition_allowed_statuses.map(number => numberToTextMap[number]).join(', ')
        })
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.search-input {
  width: 30%;
  margin-left: auto;
  margin-bottom: 10px;
}

.center {
  display: flex;
  justify-content: center;
}

.lottery-btn {
  box-shadow: none !important;
  width: fit-content;
  background: none !important;
  line-height: 30px;
  display: block;
  margin: 15px;
}
</style>
